import { memo } from "react"

import { Heading, Icon } from "@oysterhr/ui"
import { DownloadLink } from "@oysterhr/schema"
import { RequireField } from "~/app/utils/typeUtils"
import { useTranslation } from "react-i18next"
import { calculateFileSize } from "./helpers"
import { fullDateTime } from "@oysterhr/common"

interface DocumentDrawerProps {
  file?: RequireField<DownloadLink, "createdAt" | "byteSize">
}

export const DocumentDrawer = memo(({ file }: DocumentDrawerProps) => {
  const { t } = useTranslation("components/FileViewer")
  if (!file) return null
  const { title = t("unnamedDocument"), createdAt, byteSize } = file
  return (
    <div className="flex flex-grow flex-col px-10">
      <div className="mb-4">
        <Icon name="FilePdf" className="text-error-base" size="md" />
      </div>
      <div>
        <Heading size="2xl" as="h2" className="text-gray-400">
          {title}
        </Heading>
      </div>
      <div className="pt-8">
        <div className="mb-4 leading-5 text-gray-400">Created on</div>
        <div className="font-normal leading-5 text-gray-400">{fullDateTime(createdAt)}</div>
      </div>
      <div className="pt-8">
        <div className="font-normal leading-5 text-gray-400">{calculateFileSize(byteSize)}</div>
      </div>
    </div>
  )
})

DocumentDrawer.displayName = "DocumentDrawer"
